import * as React from 'react'
import { signOut } from '../../utils/auth'
import Logo from '../icons/ui/Logo'
import Logout from '../icons/ui/ArrowRight'

const RiderLandingPage = (props: { user: any }) => {
  return (
    <div
      className='absolute top-0 bottom-0 left-0 right-0 flex flex-column justify-center items-center'
      style={{
        backgroundImage: `url('/images/driver/landing.webp')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      {/* <div className='absolute top-0 right-0 mt2 mr3 font-white flex' onClick={signOut}>
        Logout <Logout className='ml1' width={10} fill='white' />
      </div> */}
      <Logo className='icon--89x137 mb2' />
      <h1 className='font-white mb2'>Welcome to Goin!</h1>
      <div className='flex items-center'>
        <img src='/images/rider/app-0.webp' className='mr4' style={{ width: '320px' }} />
        <div className='flex flex-column'>
          <a href='https://play.google.com/store/apps/details?id=com.goin.rider.app&hl=en_AU' className='mb3 w100'>
            <img
              className='w100'
              src='https://lh3.googleusercontent.com/qF9r3ZjtgG-qyHdmjecArtKiulz1gmwL_xl9R3_fzk6igSeoN0wYbJSKEX5d_fxJRwYZJpHbqcLB3i9atl-9dOfUl9an7U43TfZ9PtQ=s0'
            />
          </a>
          <a href='https://apps.apple.com/us/app/goin-rides-for-all/id1363873138'>
            <img className='w100' src='/images/driver/appstore.svg' />
          </a>
        </div>
      </div>
    </div>
  )
}

export default RiderLandingPage



// WEBPACK FOOTER //
// ./src/components/riders/LandingPage.tsx